const FilterTaxonomyPermissions = {
  edit: 'filterTaxonomy:edit',
  create: 'filterTaxonomy:create',
  delete: 'filterTaxonomy:delete',
  view: 'filterTaxonomy:view',
}

export default FilterTaxonomyPermissions
